import { convertJsonToHtml } from "./convertJsonToHtml"
import store from "@/store"

export function generateForDocEngine() {
    const emailData = store.state.emailData;
    let html = convertJsonToHtml(emailData, false);

    // Ersetze <br> durch <br></br>
    html = html.replace(/<br>/g, '<br/>');

     // Ersetze <hr> durch <hr></hr>
     html = html.replace(/<hr>/g, '<hr/>');

    // Ersetze HTML-Escape-Zeichen zurück
    html = html.replace(/&lt;/g, '<').replace(/&gt;/g, '>');

    // Ersetze &nbsp; durch normales Leerzeichen
    html = html.replace(/&nbsp;/g, '&#160;')

    // Entferne <!DOCTYPE html> und unnötige Zeilenumbrüche am Anfang
    html = html.replace(/<!DOCTYPE html>/i, '').trim();

   // Ersetze <div class="placeHolderDescription"> durch <div class="placeHolderDescription" style="display: none;">
    html = html.replace(/<div class="placeHolderDescription">/g, '<div class="placeHolderDescription" style="display: none;">');

    //Escapen von -- durch &#45;&#45; innerhalb img tags
    html = html.replace(/<img\b[^>]*\bsrc="([^"]*?)--([^"]*?)"/g, (match, beforeDash, afterDash) => {
        return match.replace(`${beforeDash}--${afterDash}`, `${beforeDash}&#45;&#45;${afterDash}`);
    });
    

    // Ersetze <div class="placeHolder" contenteditable="false"> durch <div class="placeHolder" contenteditable="false" style="display: none;">
    //html = html.replace(/<div class="placeHolder" contenteditable="false">/g, '<div class="placeHolder" contenteditable="false" style="display: none;">');



    // XSL-Vorlage um den HTML-Inhalt herum einfügen
    const xslTemplate = `<?xml version="1.0" encoding="utf-8"?>
<xsl:stylesheet version="2.0" xmlns="http://www.w3.org/1999/xhtml" xmlns:fn="http://www.w3.org/2005/xpath-functions" xmlns:xs="http://www.w3.org/2001/XMLSchema" xmlns:xsl="http://www.w3.org/1999/XSL/Transform">
    <xsl:output encoding="UTF-8" indent="no" method="xml" version="1.0"/>
    <xsl:decimal-format decimal-separator="." grouping-separator="," name="us"/>
    <xsl:decimal-format decimal-separator="," grouping-separator="." name="eu"/>
    <xsl:template match="/">
        ${html}
    </xsl:template>
</xsl:stylesheet>`;
    console.log(xslTemplate)
    return xslTemplate;
}
